import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, StaffAvailabilityException, StaffAvailabilityExceptionBulkCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateStaffAvailabilityException(): UseMutationResult<
  AxiosResponse<StaffAvailabilityException[]>,
  AxiosError<ErrorMessage>,
  StaffAvailabilityExceptionBulkCreate
> {
  const queryClient = useQueryClient();

  const mutationFn = (
    staffAvailabilityExceptionWrite: StaffAvailabilityExceptionBulkCreate,
  ): Promise<AxiosResponse<StaffAvailabilityException[]>> => {
    return client.post('staff-availability-exceptions/bulk-create/', staffAvailabilityExceptionWrite);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('staff-availability-exceptions');
    },
  });
}
